// import Vue from 'vue';
import ContractsService from '@/services/API/ContractsService';
import PaymentModal from '@/modules/PaymentSystem/components/PaymentModal.vue';
import DiscountModal from '@/modules/PaymentSystem/components/DiscountModal.vue';

import store from '@/store';
import { modalsController } from '@/plugins/modals';
import {
  addDays,
  format,
} from 'date-fns';

import { Centrifuge } from 'centrifuge';
import Chat from '@/models/list/Chat';

const STATUSES = {
  fail: {
    text: 'Платеж не прошел',
    color: 'error',
    methodName: 'failPayment',
  },
  success: {
    text: 'Платеж прошел успешно',
    color: 'success',
    methodName: 'successPayment',
  },
};
const PAYMENT_STATUSES = {
  CONFIRMED: STATUSES.success,
  AUTHORIZED: STATUSES.success,
  REJECTED: STATUSES.success,
};

export default class Contracts {
  constructor({
    id,
    sum,
    act,
    users,
    number,
    document,
    owner,
    owner_id: ownerId,
    is_active: isActive,
    sum_total: totalSum,
    sum_discount: sumDiscount,
    prepayment_percent: prepaymentPercent,
    prior_record_id: priorRecordId,
    typical_contract: typicalContract,
    typical_contract_id: typicalContractId,
    typical_contract_discount: typicalContractDiscount,
    listener_preview_document: listenerPreviewDocument,
    is_viewed: isViewed,
    is_concluded: isConcluded,
    transactions,
    date_at: dateAt,
    is_signed_customer: isSignedCustomer,
    is_signed_executor: isSignedExecutor,
    is_signed_customer_act: isSignedCustomerAct,
    is_signed_executor_act: isSignedExecutorAct,
  }) {
    this.id = id;
    this.sum = sum;
    this.act = act;
    this.users = users;
    this.qr_code = null;
    this.number = number;
    this.owner = owner;
    this.owner_id = ownerId;
    this.is_active = isActive;
    this.sum_total = totalSum;
    this.sum_discount = sumDiscount;
    this.prior_record_id = priorRecordId;
    this.prepayment_percent = prepaymentPercent;
    this.typical_contract = typicalContract;
    this.typical_contract_id = typicalContractId;
    this.typical_contract_discount = typicalContractDiscount;
    this.openPaymentPDF = this.openPaymentPDF.bind(this);
    this.isMyEnrollment = this.getMyEnroll();
    this.payment_url = null;
    this.paymentMessage = null;
    this.getQr = this.getQr.bind(this);
    this.transactions = (transactions || []).map((i) => ({ ...i, sum: (i.sum / 100) }));
    this.preview_document = null;
    this.listener_preview_document = listenerPreviewDocument;
    this.is_viewed = isViewed || false;
    this.is_concluded = isConcluded;
    this.date_at = dateAt;
    this.document = document;
    this.is_signed_customer = isSignedCustomer;
    this.is_signed_executor = isSignedExecutor;
    this.is_signed_customer_act = isSignedCustomerAct;
    this.is_signed_executor_act = isSignedExecutorAct;
    this.paymentFeedBack = null;
    this.chat = {};
    this.paymentLoading = false;
    // this.getPayments();

    // this.getPreviewDocument();
    this.getChat();
  }

  get sumWhitoutDiscount() {
    if (+this.sum_discount) return this.sum;
    if (this.typical_contract_discount) {
      return (this.sum_total / (100 - this.typical_contract_discount.percent)) * 100;
    }
    return null;
  }

  get userViewContract() {
    const userId = store.getters['auth/userData'].id;
    return this.users.find(({ id }) => id === userId).is_viewed;
  }

  set userViewContract(val) {
    const userId = store.getters['auth/userData'].id;
    const index = this.users.findIndex(({ id }) => id === userId);
    this.users[index].is_viewed = val;
  }

  get paymentPercent() {
    return Math.ceil((this.payment / +this.sum_total) * 100);
  }

  get isPaymentPrePayment() {
    return this.paymentPercent >= this.prepayment_percent;
  }

  get prePaymentValue() {
    return +this.sum_total * (this.prepayment_percent / 100);
  }

  get isAllPayed() {
    return this.payment >= +this.sum_total;
  }

  get payment() {
    let result = 0;
    this.transactions.forEach((i) => {
      result += i.sum;
    });
    return result;
  }

  get maxPayment() {
    return this.sum_total - this.payment;
  }

  get needToSign() {
    const { is_signed_customer: customer, is_signed_executor: executor, isMyEnrollment } = this;

    const checkedValue = !isMyEnrollment ? !executor && customer : (customer && !executor);
    return checkedValue;
  }

  async getPreviewDocument() {
    const { data } = await ContractsService.getContractNoModel(this.id, {
      expand: 'preview_document',
    });
    console.log(data);
    this.preview_document = data.data.preview_document;
  }

  getDays(enrollment, type) {
    // - period_end, end_learning
    const amount = this.typical_contract.day_before_course_end;
    return format(addDays(new Date(enrollment[type]), -amount), 'dd.MM.yyyy');
  }

  async getChat() {
    const { data } = await ContractsService.getRoomContract(this.id, { expand: 'exists_unread_messages' });
    const noInit = true;
    const chat = new Chat(data.data, noInit);
    const onOpen = () => { store.dispatch('messages/GET_AGREEMENT'); };
    chat.bindOnOpen(() => { onOpen(); });
    this.chat = chat;
  }

  openPaymentModal(isEnrollment) {
    modalsController.show('generic-controller', {
      title: 'Оплата по договору',
      component: PaymentModal,
      dialogProps: {
        width: 800,
      },
      'component-props': {
        paymentValue: this.isPaymentPrePayment
          ? this.maxPayment : (this.prePaymentValue - this.payment),
        contract: this,
        needToPay: isEnrollment,
        save: (val) => { this.users = val; },
      },
    });
  }

  openDiscountModal() {
    modalsController.show('generic-controller', {
      title: 'Установите сумму скидки',
      component: DiscountModal,
      dialogProps: {
        width: 800,
      },
      'component-props': {
        saveMethod: (val) => this.setDiscount(val),
      },
    });
  }

  async setDiscount(discount) {
    const payload = { sum_discount: discount };
    await ContractsService.setContractDiscount(this.id, payload)
      .then(({ data }) => {
        this.sum_total = data.data.sum_total;
        this.sum_discount = data.data.sum_discount;
        modalsController.close();
      });
  }

  async setPayment(val) {
    const payload = {
      sum: val,
      contract_id: this.id,
    };
    this.paymentLoading = true;
    await ContractsService.setPayment(payload)
      .then(({ data }) => this.transactions.push({
        ...data.data,
        sum: Number(data.data.sum / 100),
      }));
    modalsController.close();
    this.paymentLoading = false;
  }

  getQr(val) {
    const sum = Number(val).toFixed(2);
    ContractsService.getQR(this.id, { sum })
      .then((data) => { this.qr_code = data.data; });
  }

  startPaymentWithQr(val, email) {
    const amount = Number((val * 100).toFixed(0));
    const payload = {
      amount,
      ...email ? { email } : {},
    };
    ContractsService.startPaymentWithQr(this.id, payload, { params: { expand: 'centrifuge' } })
      .then(({ data }) => {
        this.qr_code = data.data.qr_spb;
        this.payment_url = data.data.payment_url;
        this.paymentMessage = data.data.message;
        this.setCentrifuge(data.data.centrifuge);
      });
  }

  setCentrifuge({ url, token, channel }) {
    this.centrifuge = new Centrifuge(url, { token });
    const sub = this.centrifuge.newSubscription(channel);

    sub.on('publication', ({ data }) => {
      if (Object.keys(PAYMENT_STATUSES).includes(data.status)) {
        this.paymentFeedBack = PAYMENT_STATUSES[data.status];
        if (data.status !== 'REJECTED') this.getTransactions();
      }
    });
    sub.subscribe();

    this.centrifuge.connect();
  }

  getTransactions() {
    const params = {
      'search[contract_id]': this.id,
    };
    ContractsService.getTransactions(params)
      .then(({ data }) => {
        this.transactions = data.data.map((i) => ({ ...i, sum: (i.sum / 100) }));
      });
  }

  // getPayments() {
  //   const params = {
  //     'search[contract_id]': this.id,
  //   };
  //   ContractsService.getPayments(params)
  //     .then(({ data }) => {
  //       this.transactions = data.data;
  //     });
  // }

  openPaymentPDF() {
    const sum = this.isPaymentPrePayment ? this.maxPayment : (this.prePaymentValue - this.payment);
    ContractsService.getPDF(this.id, { sum: Number(sum).toFixed(2) })
      .then((data) => {
        const blob = new Blob([data.data], { type: 'application/pdf' });
        const objectUrl = URL.createObjectURL(blob);
        window.open(objectUrl);
      });
    modalsController.close();
  }

  async viewContract() {
    await ContractsService.viewContract(this.id).then(() => {
      this.userViewContract = true;
    });
  }

  getMyEnroll() {
    return this.owner_id === store.getters['auth/userData'].id;
  }
}
